const SAVE_STATE_NONE = 'none';
const SAVE_STATE_SAVING = 'saving';
const SAVE_STATE_DONE = 'done';
const SAVE_STATE_AUTO_SAVE_DONE = 'autoSaveDone';
const SAVE_STATE_FAIL = 'fail';
const SAVE_STATE_AUTO_SAVE_FAIL = 'autoSaveFail';
const SAVE_STATE_AUTO_SAVING = 'autoSaving';
const UPDATE_SAVE_STATE = 'scratch-gui/save/UPDATE_SAVE_STATE';

const initialState = {
    saveState: SAVE_STATE_NONE
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case UPDATE_SAVE_STATE:
        return {
            saveState: action.state
        };
    default:
        return state;
    }
};

const setSaveState = function (state){
    return {
        type: UPDATE_SAVE_STATE,
        state: state
    };
};

export {
    reducer as default,
    initialState as homeworkSaveInitialState,
    setSaveState,
    SAVE_STATE_NONE,
    SAVE_STATE_DONE,
    SAVE_STATE_AUTO_SAVE_DONE,
    SAVE_STATE_SAVING,
    SAVE_STATE_AUTO_SAVING,
    SAVE_STATE_FAIL,
    SAVE_STATE_AUTO_SAVE_FAIL
};
